<div class="app-product-shopping-cart" [ngClass]="{'merchandise-padding': isMerchandiseFlow()}" [ngStyle] = "{'background-color':settingsData?.merchandise_bg_main_color, 'color':settingsData?.merchandise_font_main_color}">
  
        <div class="container">
  <div class="pointer">
    <i class="fa fa-arrow-left fs-16" aria-hidden="true" [ngStyle] = "{'background-color':settingsData?.merchandise_bg_main_color, 'color':settingsData?.merchandise_font_main_color}"></i>
    <span (click)="backClicked()" class="fs-16 ml-10">Back</span>
  </div>
  <div class="row no-gutters mt-20 mb-20">
    <div class="col 6 fs-22 fw-bold" style="margin: auto;" [ngStyle] = "{'color':settingsData?.merchandise_font_main_color}">My Shopping Cart</div>
    <div class="col 6 text-right button-class">
      <button class="flat-primary-button clear-cart-button mr-10" *ngIf="cartProductsList?.length > 1" (click)="confirmClearAll = true" [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_secondary_color,'color': settingsData?.merchandise_button_font_secondary_color}">Clear All</button>
      <button class="flat-primary-button" (click)="buyNow()" [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_primary_color,'color': settingsData?.merchandise_button_font_primary_color}">Buy Now</button></div>
  </div>
  <div class="remove-confirm mb-20" *ngIf="confirmClearAll" [style.--product-bg]="settingsData?.merchandise_bg_primary_color" [style.--product-info]="settingsData?.merchandise_font_main_color">
    <span>Remove all {{cartProductsList?.length}} items from your cart?</span>
    <ng-container *ngTemplateOutlet="confirmActions; context: { $implicit: null }"></ng-container>
  </div>
  <div class="product-cart-list p-20">
    <div class="p-20 product-tile mb-10 no-gutters" [style.--product-info]="settingsData?.merchandise_font_main_color" [style.--product-bg]="settingsData?.merchandise_bg_primary_color" *ngFor="let product of cartProductsList">
      <div class="row">

        <div  class="col-2 prod-img-div">

          <img appHideBrokenImg class="prod-img pointer" role="link" tabindex="0" [alt]="product?.product_data?.name" (click)="openProduct(product)" (keydown.enter)="openProduct(product)" src="{{ product.product_data.product_img }}">
       
        </div>
        <div class="col-7">
            <div class="mb-10 fs-20 text-caps pointer product-name-link" role="link" tabindex="0" (click)="openProduct(product)" (keydown.enter)="openProduct(product)">
            {{product?.product_data?.name}}</div>
            <div class="mb-10" *ngIf="product && product.product_data && product.product_data.short_description" >{{product.product_data.short_description}}</div>
            <div class="mb-10">
              <!-- <img src="../../../.././../assets/logo-icon.svg"  height="18px" class="mr-5"> -->
              <!-- <span  height="18px" class="mr-5">
                <app-svg [icon]="'arevea-green-symbol'"></app-svg>
              </span> -->
              {{product.price | currency: (product.currency || product.product_data.currency_type)}} 
              <!-- <span class="amount-light">($192.7)</span> -->
            </div>
            <div class="mb-10 mt-10" *ngIf="product.product_data && product.product_data.inventory > 0">Available Quantity : {{product.product_data.inventory}}</div>
            <div class="mb-10 mt-10 add-remove-button-class">Quantity: 
              <button class="flat-primary-button mlr-10" [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_secondary_color, 'color':settingsData?.merchandise_button_font_secondary_color}" (click)="product.quantity == 1 ? false: decrement(product)" [ngClass]="{'product-decrement':product.quantity == 1}">-</button>
              {{product.quantity}}
              <button class="flat-primary-button mlr-10"  [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_secondary_color, 'color':settingsData?.merchandise_button_font_secondary_color}" (click)="increment(product)">+</button>
            </div>
            <div class="delete-button-class" *ngIf="pendingRemoveId !== product.id"><button class="flat-primary-button" [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_primary_color, 'color':settingsData?.merchandise_button_font_primary_color}" (click)="pendingRemoveId = product.id; confirmClearAll = false">Delete</button></div>
            <div class="remove-confirm mt-10" *ngIf="pendingRemoveId === product.id">
              <span>Remove this item from your cart?</span>
              <ng-container *ngTemplateOutlet="confirmActions; context: { $implicit: product }"></ng-container>
            </div>
         
        </div>
        <div class="col-3" style="display: flex;">
          <div class=" " style="width: 80%; margin-right: 5px;" *ngFor="let prodAttrs of  product.product_data.attributes;let i=index" >
            <div class="dropdown app-currency d-inline-block align-self-center w-100" fxShow fxHide.xs="true"
            *ngIf="!router.url.includes('/preview') && prodAttrs.attributesList && prodAttrs.attributesList[0] && prodAttrs.attributesList[0].attribute_id != null">
            <span class="btn btn-primary btn-primary-mobile-resp dropdown-toggle gt-toggle jc-sb" [ngStyle] = "{'background-color':settingsData?.merchandise_bg_secondary_color, 'color':settingsData?.merchandise_font_secondary_color}" type="button"
              (click)="clearSearch()" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <!-- <span class="d-inline-block w-150p notranslate">
                <span *ngIf="size?.length <= 4" class="active-color v-bottom">{{ size }}</span>
                <span *ngIf="size?.length > 4" class="active-color v-bottom">
                  {{ size | slice: 0:4 }}
                  {{size?.length > 4 ? "" : ""}}
                </span> 
                Size
              </span> -->
              <span class="d-inline-block w-150p notranslate" *ngIf="prodAttrs.selected_attr"> 
                {{prodAttrs.selected_attr}}
              </span>
            </span>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2"  *ngIf="prodAttrs.attributesList && prodAttrs.attributesList.length > 0">
              <!-- <div class="relative">
                <input type="text" placeholder="Search.." class="search-input" [(ngModel)]="searchCurrency">
                <i class="fa fa-search  text-white d-search" aria-hidden="true"></i>
              </div> -->
              <div class="dropdown-div">
                <span *ngFor="let attrVals of prodAttrs.attributesList;let i=index"
                class="notranslate">
                  <a class="dropdown-item fs-13" *ngIf="attrVals.value"
                  (click)="changeAttribute(attrVals, product.id,product.product_id)">{{attrVals.value}}
                  </a>
                </span>
              </div>
            </div>
          </div>
          </div>
        </div>

      </div>
      
      
    </div>
  </div>
  <div class="mt-20 text-right fs-20 pb-4" [ngStyle] = "{'color':settingsData?.merchandise_font_main_color}">
    Subtotal ({{cartItemCount}} items) -    
    <!-- <img src="../../../.././../assets/logo-icon.svg"  height="18px" class="mr-5"> -->
    <!-- <app-svg [icon]="'arevea-green-symbol'"></app-svg> -->
    <!-- 0.267 <span class="amount-light">($192.7)</span> -->
    {{subTotal | currency : getCurrency}}
  </div>
</div>
</div>

<ng-template #confirmActions let-product>
  <div class="remove-confirm__actions">
    <button class="flat-primary-button" (click)="pendingRemoveId = null; confirmClearAll = false" [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_secondary_color, 'color':settingsData?.merchandise_button_font_secondary_color}">Cancel</button>
    <button class="flat-primary-button" (click)="product ? moveToWishlist(product) : clearCart(true)" [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_secondary_color, 'color':settingsData?.merchandise_button_font_secondary_color}">Move to Wishlist</button>
    <button class="flat-primary-button" (click)="product ? deleteProductFromCart(product.id, product.product_id) : clearCart(false)" [ngStyle] = "{'background-color':settingsData?.merchandise_button_bg_primary_color, 'color':settingsData?.merchandise_button_font_primary_color}">Remove</button>
  </div>
</ng-template>
